import { styled } from '@mui/material'
import Color from 'src/utils/Color'

interface IText {
  size?: number
  color?: string
  align?: 'center' | 'right'
  bold?: boolean
}
const textKeys: PropertyKey[] = ['size', 'color', 'align', 'bold']

const Text = styled('p', {
  shouldForwardProp: (prop) => !textKeys.includes(prop),
})<IText>((props) => ({
  margin: 0,
  fontWeight: props.bold ? 'bold' : 'normal',
  fontSize: props.size ? props.size : 16,
  color: props.color || Color.baseFontColor,
  textAlign: props.align || 'left',
  fontFamily: `"ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN", "メイリオ", Meiryo, Verdana, Roboto, "Droid Sans", "游ゴシック", YuGothic, sans-serif`,
}))

export default Text
